/**
 * Scene Canvas 2D version
 * @class SimpleScene
 * @param {HTMLCanvasElement} element
 * @param {Array} uris
 * @extends Scene
 */
function SimpleScene(element, uris) {
	Scene.call(this, element);
	//TODO do more tests
	this._context = element.getContext("2d");
	this._uris = uris;
	this._numFrames = uris.length;
	this._imagesLoadHandlerBound = this._imagesLoadHandler.bind(this);
}

//Inheritance
SimpleScene.prototype = Object.create(Scene.prototype);
SimpleScene.prototype.constructor = SimpleScene;

SimpleScene.prototype._numFrames = 0;
/** @type Array */
SimpleScene.prototype._frames = null;
/** @type Array */
SimpleScene.prototype._uris = null;
/** @type Number */
SimpleScene.prototype._numFramesLoaded = 0;
/** @type Function */
SimpleScene.prototype._imagesLoadHandlerBound = null;

SimpleScene.prototype.draw = function draw(positionX, positionY) {
	if(!this._loaded){
		return;
	}

	var frame = this._frames[Math.round(positionX * (this._numFrames - 1))];
	var frameWidth = frame.naturalWidth;
	var frameHeight = frame.naturalHeight;
	var canvasWidth = this._element.width;
	var canvasHeight = this._element.height;
	// find the minimum size of the corresponding width that match _canvas and the real size of image
	var srcWidth = Math.min(frameWidth, canvasWidth * (frameHeight / canvasHeight)/*width of image should have to match ratios*/);
	// align center (if src width is smaller than original)
	var srcX = srcWidth < frameWidth ? (frameWidth - srcWidth) / 2 : 0;
	var destWidth = Math.min(canvasWidth, srcWidth * (canvasHeight / frameHeight));
	var destX = destWidth < canvasWidth ? (canvasWidth - destWidth) / 2 : 0;
	this._context.drawImage(
		// image
		frame,
		// sx
		srcX,
		// sy
		0,// always 100% of height
		// sw
		srcWidth,
		// sh
		frameHeight,// always 100% of height
		// dx
		destX,
		// dy
		0,// always 100% of height
		// dw
		destWidth,
		// dh
		canvasHeight// always 100% of height
	);
};

/**
 * Test the capability
 * @param {HTMLCanvasElement} element
 * @returns {boolean}
 */
SimpleScene.test = function test(element){
	var matchType;
	var context;
	// We need a clone to test getContext() on it
	element = element.cloneNode();

	try{
		matchType = element instanceof HTMLCanvasElement;
	}catch(error){
		return false;
	}

	if(!matchType){
		return false;
	}

	// Try Canvas2D
	try{
		context = element.getContext("2d");
	}catch(error){
		return false;
	}

	return context !== null;
};

SimpleScene.prototype.load = function load(){
	this._numFramesLoaded = 0;
	this._loaded = false;
	this._frames = new Array(this._numFrames);
	for(var index = 0; index < this._numFrames; ++index) {
		/** @type {HTMLImageElement}*/
		var frame = this._frames[index] = new Image();
		frame.addEventListener("load", this._imagesLoadHandlerBound, false);
		//TODO handle error event
		frame.src = this._uris[index];
	}
};

SimpleScene.prototype._imagesLoadHandler = function _imagesLoadHandler(event) {
	event.currentTarget.removeEventListener("load", this._imagesLoadHandlerBound, false);
	this._dispatchProgressEvent(this._numFramesLoaded, this._numFrames);

	if(++this._numFramesLoaded >= this._numFrames) {
		this._loaded = true;
		this._dispatchLoadEvent();
	}
};

SimpleScene.prototype.clear = function clear(){
	Scene.prototype.clear.call(this);

	for(var index = 0; index < this._numFrames; ++index) {
		/** @type {HTMLImageElement}*/
		var frame = this._frames[index];
		frame.removeEventListener("load", this._imagesLoadHandlerBound, false);
		frame.src = "";// we can free images, since it's drawn in a canvas
	}

	return true;
};